import history from '../../../history';
import { shopUserLogout as query } from '../../lib/graphql';
import {
    SHOP_USER_LOGOUT_START,
    SHOP_USER_LOGOUT_SUCCESS,
    SHOP_USER_LOGOUT_ERROR,
    SET_RUNTIME_VARIABLE
} from '../../../constants/index';

export function shopLogout() {
    return async (dispatch, getState, { client }) => {

        dispatch({
            type: SHOP_USER_LOGOUT_START
        });

        try {
            const { data } = await client.query({
                query,
                fetchPolicy: 'network-only'
            })
            if (data?.shopUserLogout?.status === 200) {
                window.location.reload();
                // await history.push('/restaurant');
                await dispatch({
                    type: SHOP_USER_LOGOUT_SUCCESS
                });

                await dispatch({
                    type: SET_RUNTIME_VARIABLE,
                    payload: {
                        name: 'isRestaurantAuthenticated',
                        value: false
                    }
                });

            } else {
                dispatch({
                    type: SHOP_USER_LOGOUT_ERROR
                });
            }
        } catch (error) {
            dispatch({
                type: SHOP_USER_LOGOUT_ERROR
            });
            return false;
        }
        return true;
    }
}